export default __webpack_public_path__ + "static/look-6-6081e42c92dac7b3a2f142024b13abf1.png";